import { Link } from 'react-router-dom';
import ComicCard from '@/components/base/ComicCard';
import { popularComics } from '@/mocks/comics';

export default function PopularComics() {
  return (
    <section className="py-10 md:py-14">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground-900">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-1">最受读者欢迎的韩国漫画精选</p>
          </div>
          <Link
            to="/category/romance"
            className="text-sm text-primary-500 hover:text-primary-600 transition-colors duration-200 flex items-center gap-1 whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {popularComics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}